import React from 'react'
import BoxSizeSelector from './BoxSizeSelector'
import { DropdownSection } from 'live/components/ui/dropdown-toggler'
import styled, { createGlobalStyle } from 'styled-components'
import { LiveMultiValuesWidgetConfig } from '../api'

export function LiveMultiValuesEditorConfigForm(props: LiveWidgetConfigForm['defaultProps']): JSX.Element {
    return (
        <div className="live-multi-values-editor-config-wrapper">
            <EditorGlobalStyles />
            <EditorConfigWrapper>
                <BoxSizeSelector
                    onChange={props.onChangeLayoutConfig}
                    config={props.config as LiveMultiValuesWidgetConfig}
                />
            </EditorConfigWrapper>
        </div>
    )
}

export function LiveMultiValuesDashboardConfigForm(props: WidgetTypeActionProps): JSX.Element {
    return (
        <div className="live-multi-values-dashboard-config-wrapper">
            <DashboardGlobalStyles />
            <DropdownSection className="live-multi-values-box-size-wrapper">
                <DashboardTooltipConfigWrapper>
                    <BoxSizeSelector
                        variant="dark"
                        onChange={props.changeConfig}
                        config={props.widgetConfig as LiveMultiValuesWidgetConfig}
                    />
                </DashboardTooltipConfigWrapper>
            </DropdownSection>
        </div>
    )
}

const DashboardGlobalStyles = createGlobalStyle`
    .live-multi-values-dashboard-config-wrapper + div {
        display: none;
    }
`

const EditorGlobalStyles = createGlobalStyle`
    .config-form.axis + div {
        //display: none;
    }
`
const DashboardTooltipConfigWrapper = styled.div`
    .tooltip-options ul {
        gap: 10px;

        > li {
            margin-right: 0;
        }
    }
`

const EditorConfigWrapper = styled.div`
    .tooltip-options ul {
        gap: 3px;
        justify-content: space-around;

        > li {
            margin-right: 0;
        }
    }
`
